import React, { useEffect } from "react";
import Lot from "./sell";
const View = (props) =>{
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const data = params.get("data");

  const callMeta = async () => {
    let dataSend = {
      title: 'Private Art Sale | Exclusive Paintings at Leon Gallery',
      discription: 'Browse exclusive private sales of curated paintings at Leon Gallery. Discover rare artworks and masterpieces available for private purchase. Secure your painting today.',
      lotNo: '',
      canonical: 'https://leon-gallery.com/sale?data=PAINTING',
      url: 'https://leon-gallery.com/sale?data=PAINTING',
      imagUrl: 'https://leon-gallery.com/static/media/dddd.f96bbcbee8c8c2f5e3ee.png',
    };

    await fetch(`https://leon-gallery.com/meta`, {
      method: "POST",
      body: JSON.stringify(dataSend),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("data send here ", data);
      })
      .catch((error) => {
        // alert.error(error)
        console.log("error ", error);
      });
  }


useEffect(() => {
return callMeta();
},[])

  return (
    <div>
      {/* <section
        className="breadcrumb-area"
        style={{ backgroundImage: "url(/images/breadcrumb/breadcrumb-1.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">

              <div className="inner-content clearfix">
                <div className="title">
                  <h1>{data}</h1>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Lot data={data} />
    </div>
  );
}

export default View;
